export default __webpack_public_path__ + "static/media/br_ad_banner.c5ca2169.jpg";